import { makeStyles, shorthands } from '@fluentui/react-components';

export const useSearchResultViewStyle = makeStyles({
  searchResultView: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.margin('32px', '36px'),
    ...shorthands.gap('24px'),
  },
  breadcrumbButton: {
    '&.fui-BreadcrumbButton': {
      color: '#0F6CBD',
    },
  },
  breadcrumbButtonCurrent: {
    '&.fui-BreadcrumbButton': {
      color: '#424242',
      fontWeight: 400,
    },
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('8px'),
    marginTop: '24px',
    marginBottom: '24px',
  },
  headerTitle: {
    fontSize: '28px',
    fontWeight: 600,
  },
  defaultSearchQuery: {
    color: '#464FEB',
    fontStyle: 'italic',
  },
});
